import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoginComponent } from 'src/app/pages/pre-auth/login/login.component';
import { AuthService } from '../../services/auth.service';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  public isLogged = false;
  public username = '';
  public type_of_account = '';
  public userInSession = null;
  public activeOption = '';
  public activeOptionM = '';
  public usuario = null;
  public rutaWorlds = '#worlds';
  public rutaWorldsM = 'auth/#worlds';
  public rutaSoluction = '#soluction';
  public rutaSoluctionM = 'auth/#soluction';
  public loginFromDemo = 'false';

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private svUtils: UtilsService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.loginFromDemo = localStorage.getItem('loginFromDemo');
    this.activeOptionM = this.router.url.replace('/auth/', '');
    this.getLoggedUser();
  }
  goTo(url) {
    window.open(url, '_blank');
  }
  goToWorlds() {
    this.router.navigate([`/`]);
    this.activeOption = 'worlds';
  }
  goToWorldsM() {
    this.router.navigate([`/`]);
    this.activeOption = 'auth/worlds';
  }
  goToSoluction() {
    this.router.navigate([`/`]);
    this.activeOption = 'soluction';
  }
  getOptionSeleted(option) {
    this.router.navigate([`/${option}`]);
    this.activeOption = option;
  }
  getOptionSeletedM(option) {
    this.router.navigate([`${option}`]);
    this.activeOptionM = option;
  }
  goToHome() {
    this.router.navigate(['/']);
  }
  goToHomeM() {
    this.router.navigate(['auth/home']);
  }
  goToInitM() {
    this.router.navigate(['auth']);
  }
  goToPlans() {
    this.activeOption = 'plans';
    this.router.navigate(['/plans']);
  }
  goToPlansM() {
    this.activeOption = 'plans';
    this.router.navigate(['auth/plans']);
  }
  goToM(opcion) {
    this.activeOptionM = opcion;
    this.router.navigate([opcion]);
  }
  openLoginModal(action): any {
    localStorage.setItem('loginFromDemo', 'false');
    const dialogRef = this.dialog.open(LoginComponent, {
      width: '420px',
      height: '650px', //action=="login"?"450px":"650px",
      maxHeight:'95vh',
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: { action: action },
    });
  }

  getLoggedUser() {
    this.usuario = this.svUtils.getLoggedUser();
  }

  logout(): void {
    this.authService.logout(this.usuario['id_usuario']);
    this.router.navigate(['']);
  }
}
